import React,{useContext} from "react";
import contentStyle from "./contentStyle.module.css";

//import image
import img from "../../assets/photo.png";
//material ui
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import SearchIcon from "@mui/icons-material/Search";
import {makeStyles} from '@material-ui/core';
//import components
import Cources from "../Content/Cources"
import Article from "../Content/Article"
//import context
import {CourcesContext} from '../../context/CourcesContextProvider'




const useStyles=makeStyles({
  tesxFile:{ fontFamily:"vazir",color:"error"}
})

const Content = () => {


const cources=useContext(CourcesContext)
  const classes=useStyles()
  return (
    
    <Container maxWidth="xl">
      <div className={contentStyle.main}>
        <section className={contentStyle.container}>
          <div className={contentStyle.imageContainer}>
            <img
            className={contentStyle.img}
              style={{
                width: "100%",
                heigth: "100%",
                borderRadius: "10px 10px 0 0 ",
              }}
              src={img}
              alt="top"
            />
          </div>
          <div className={contentStyle.description}>
            <h2>برنامه نویسی را به ساده ترین زبان ممکن یاد بگیرید.</h2>
            <p>
              {" "}
              آکادمی یک وب‌سایت آموزشی در زمینه برنامه نویسی است. در آکادمی تلاش
              می‌کنیم تا مفاهیم به روز و کاربردی را با نگاهی دقیق و به صورت جامع
              بررسی کنیم. مهم‌ترین هدف ما در آکادمی درک مفاهیم برنامه نویسی
              به ساده‌ترین زبان ممکن است.
            </p>
             <TextField
            sx={{
              fontFamily: 'vazir',
            }}
            className={classes.tesxFile}
              id="demo-helper-text-misaligned-no-helper"
              color="primary"
              label={<SearchIcon />}
              variant="outlined"
              placeholder="دنبال چی میگردی؟"
            />
          
          </div>
        </section>
        <h2 className={contentStyle.h2}>دوره های آموزشی</h2>
        <Cources Cources={cources}/>
        <h2 className={contentStyle.h2}>مقالات</h2>
      <Article/>
      </div>
    </Container >

  );
};

export default Content;
